import React, {useState, useCallback, useEffect, useRef} from 'react';
import Dropzone, {useDropzone} from 'react-dropzone';
import axios from 'axios';
import Cookies from 'js-cookie';
import {Link, useNavigate, useSearchParams} from 'react-router-dom';
import LinearProgress from '@mui/material/LinearProgress';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import {IotDropzoneIcon, DragNDrop} from '../../assets';
import Swal from 'sweetalert2';
import {Box} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {Loader} from '../Loader';
import {Language} from '../../context/LanguageContext';
import {useUser} from '../../hooks';

export default function DocumentationDropzone({onChange}) {
  const {language, newObj} = Language();
  const [searchParams] = useSearchParams();
  const [progress, setProgress] = useState(0);
  const [steps, setSteps] = useState(0);
  const {createDocumentation} = useUser();
  const [payload, setPayload] = useState({
    name: '',
    type: 'file',
    parentId: '',
    path: '',
  });
  const [file, setFile] = useState();
  const [uploadStatus, setUploadStatus] = useState('Uploading...');
  const tokens_session = Cookies.get('token');
  const apiUrl = process.env.REACT_APP_MAIN_URL;
  const lang = useRef(language);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    onChange(steps);
  }, [steps]);

  useEffect(() => {
    setPayload({
      ...payload,
      parentId: searchParams.get('parentId'),
      path: searchParams.get('path'),
    });
  }, [searchParams.get('parentId'), searchParams.get('path')]);

  const getFileExtension = (filename) => {
    // Split the filename by dot to get the file parts
    const fileParts = filename.split('.');

    // Get the last part which should be the file extension
    const fileExtension = fileParts[fileParts.length - 1];

    // Return the file extension in lowercase
    return fileExtension.toLowerCase();
  };

  const uploadFile = async (file) => {
    setSteps(1);
    setFile(file);
  };

  useEffect(() => {
    lang.current = language;
  }, [language]);

  const handleRenderConfigure = (type) => {
    switch (type) {
      case 'documentation':
        break;

      default:
        break;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let eventSource = new EventSource(`${apiUrl}/dokumentasi/progress`);
    setSteps(2);
    setProgress(0);
    let response;
    let guidValue;
    const formData = new FormData();
    formData.append('file', file);
    formData.append('name', payload.name);
    formData.append('type', payload.type);
    formData.append('parentId', payload.parentId);
    formData.append('path', payload.path);
    eventSource.addEventListener('GUI_ID', async (event) => {
      console.log(`Guid from server: ${guidValue}`);
      guidValue = event.data.replace(/"/g, '');
      formData.append('guid', guidValue);
      eventSource.addEventListener(guidValue, (event) => {
        const result = JSON.parse(event.data);
        if (progress !== result.progress) {
          setProgress(result.progress);
        }
        if (uploadStatus !== result?.status) {
          setUploadStatus(result?.status);
        }
        if (result?.status === 'Done!') {
          eventSource.close();
        } else if (result.status === 'Error!') {
          setProgress(0);
          onChange(0);
          eventSource.close();
        }
      });

      response = await createDocumentation(tokens_session, formData);

      if (response.status === 200) {
        setSteps(3);
        eventSource.close();
      } else {
        setSteps(0);
        setProgress(0);
        onChange(0);
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: response.data.message,
        });
        eventSource.close();
      }
    });
    eventSource.onerror = (event) => {};
  };

  const onDrop = useCallback((acceptedFiles) => {
    // Handle the dropped files here
    acceptedFiles.forEach((file) => {
      uploadFile(file);
    });
  }, []);
  const {
    acceptedFiles,
    fileRejections,
    getRootProps,
    getInputProps,
    isDragActive,
    rejectedFiles,
    isDragReject,
  } = useDropzone({
    onDrop,
    multiple: false,
    minSize: 0,
  });
  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        position: 'relative',
      }}
      {...(steps === 0 && getRootProps())}
    >
      {steps === 0 && (
        <input
          {...getInputProps()}
          style={{
            display: 'block',
            position: 'absolute',
            top: '0',
            left: '0',
            width: '100%',
            height: '100%',
            opacity: '0',
            cursor: 'pointer',
          }}
        />
      )}
      <div
        style={{
          width: '100%',
          height: '100%',
        }}
      >
        {steps === 0 && (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              flexDirection: 'column',
              justifyContent: 'center',
              height: '100%',
              gap: '20px',
              cursor: 'pointer',
            }}
          >
            <div>
              <img src={DragNDrop} alt='drag' style={{width: '200px'}} />
            </div>
            <p
              style={{
                color: 'white',
                display: 'flex',
                alignItems: 'center',
                textAlign: 'center',
                justifyContent: 'center',
                width: '100%',
              }}
            >
              {!isDragActive &&
                newObj.DragdropsomefileshereorclicktoselectfilesWord[language]}
              {isDragActive && !isDragReject && newObj.DropHereWord[language]}
              {isDragReject && `File type not accepted, sorry!`}
            </p>
          </div>
        )}
        {steps === 1 && (
          <div
            style={{
              height: '100%',
            }}
          >
            <form
              method='post'
              style={{
                display: 'flex',
                alignItems: 'center',
                flexDirection: 'column',
                justifyContent: 'center',
                marginTop: '20px',
                width: '100%',
                padding: '0px 30px',
              }}
              onSubmit={handleSubmit}
            >
              <label
                style={{
                  width: '100%',
                  color: 'white',
                  marginBottom: '10px',
                }}
                htmlFor='documentation_name'
              >
                Name
              </label>
              <input
                style={{
                  width: '100%',
                  padding: '10px',
                  borderRadius: '5px',
                  border: '1px solid white',
                  color: '#000',
                }}
                id='documentation_name'
                type='text'
                name='name'
                value={payload.name}
                onChange={(e) => setPayload({...payload, name: e.target.value})}
              />
              <label
                style={{
                  width: '100%',
                  color: 'white',
                  marginBottom: '10px',
                  marginTop: '10px',
                }}
                htmlFor='documentation_path'
              >
                Path
              </label>
              <input
                style={{
                  width: '100%',
                  padding: '10px',
                  borderRadius: '5px',
                  border: '1px solid white',
                  color: 'white',
                }}
                id='documentation_path'
                type='text'
                name='path'
                value={payload.path}
                disabled
              />
              <button
                style={{
                  width: '100%',
                  padding: '10px',
                  borderRadius: '5px',
                  border: 'none',
                  color: 'white',
                  marginTop: '10px',
                  cursor: 'pointer',
                  background: '#5076ee',
                }}
              >
                Upload
              </button>
            </form>
          </div>
        )}
        {steps === 2 && (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '100%',
              height: '100%',
            }}
          >
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '100%',
                height: '100%',
                flexDirection: 'column',
              }}
            >
              <p
                style={{
                  color: 'white',
                  textAlign: 'center',
                }}
              >
                {uploadStatus}
              </p>
              <LinearProgress
                variant='determinate'
                value={progress}
                sx={{
                  height: '10px',
                  width: '100%',
                  marginTop: '10px',
                }}
              />
            </div>
          </div>
        )}

        {steps === 3 && (
          <div
            style={{
              display: 'flex',
              height: '100%',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '15px',
            }}
          >
            <div
              style={{
                // margin: "50px 0",
                color: 'white',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '10px',
              }}
            >
              <CheckCircleOutlineIcon
                style={{color: 'lightgreen', fontSize: '100px'}}
              />
              {newObj.FileUploadedSuccessfully[language]}
            </div>

            <Link to='/documentation' style={{width: '100%'}}>
              <button
                style={{
                  backgroundColor: 'white',
                  border: '1px solid white',
                  padding: '15px',
                  width: '100%',
                  borderRadius: '10px',
                  cursor: 'pointer',
                }}
              >
                {newObj.DocumentationWord[language]}
              </button>
            </Link>

            <Link to='/adminpage' style={{width: '100%'}}>
              {' '}
              <button
                style={{
                  backgroundColor: 'transparent',
                  border: '1px solid white',
                  color: 'white',
                  padding: '15px',
                  width: '100%',
                  borderRadius: '10px',
                  cursor: 'pointer',
                }}
              >
                {newObj.AdministratorWord[language]}
              </button>
            </Link>
          </div>
        )}
      </div>
    </div>
  );
}
